import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Paper, Divider } from "@mui/material";
import { GUEST_BOND_OPTIONS } from "../guestBondOptions";

export default function GuestBondTypeGrid({ onSelectPath }) {
  return (
    <>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0f172a", mb: 1.5 }}>
        Choose a bond type
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
        }}
      >
        {GUEST_BOND_OPTIONS.map((item) => (
          <Paper
            key={item.title}
            elevation={0}
            onClick={() => onSelectPath(item.path)}
            sx={{
              p: 2.5,
              cursor: "pointer",
              backgroundColor: "#fff",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 3,
              transition: "all 0.25s ease",
              boxShadow: "0 4px 16px rgba(15,23,42,0.04)",
              "&:hover": {
                borderColor: "#0f172a",
                transform: "translateY(-3px)",
                boxShadow: "0 12px 30px rgba(15,23,42,0.10)",
              },
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#0f172a", mb: 0.5 }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {item.description}
            </Typography>
          </Paper>
        ))}
      </Box>
    </>
  );
}

GuestBondTypeGrid.propTypes = {
  onSelectPath: PropTypes.func.isRequired,
};
